<template>
  <div>
    <!-- 直销统计 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>直销统计</el-breadcrumb-item>
    </el-breadcrumb>
   
    <div class="tab">
      <span
        v-for="(v,i) in tabBtn"
        :key="v.id"
        @click="tabTitle(i)"
        :class="activeIndex==i?'activeTab':''"
      >{{v.name}}</span>
    </div>
    <div class="title_box">
        <span>日期：</span>
        <el-date-picker
          v-model="headBox.Times"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          value-format="yyyy-MM-dd"
          end-placeholder="结束日期"
        ></el-date-picker>
       
        <span>展示内容：</span>
        <el-select v-model="headBox.type"  placeholder="每日">
            <el-option
              v-for="item in option"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
        </el-select>
        <el-select v-model="headBox.productid" filterable placeholder="全部产品" v-if="headBox.type=='2'">
            <el-option
              v-for="item in proDuctOption"
              :key="item.ProductID"
              :label="item.ProductName"
              :value="item.ProductID"
            ></el-option>
        </el-select>
        <div class="chaxuns" @click="chaxun">查询</div>
        <div class="chaxuns" style="margin-left:2rem;" @click="exportRoute">去导出</div>
    </div>
    <div class="statistics">
        <div v-for="(item,index) in distri" :key="index">
          <div class="tics_title">
            <!-- <span>{{ item.text }}</span> -->
            <span>{{ item.text1 }}</span>
          </div>
          <div class="tics_imgs">
            <div>
              <span>{{ item.num }}</span>
              <span>{{ item.suffix }}</span>
            </div>
            <img :src="item.img" alt="">
          </div>
        </div>
    </div>
    <el-card>
      <!-- 销售统计 -->
      <div v-if="activeIndex==0">
        <!-- <div class="titleSear">
          <el-input placeholder="产品名称" v-model="data.ProductName"></el-input>
          <el-button @click="zhixiaoBtns">查询</el-button>
        </div> -->
        <div >
          <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          v-loading="loading"
          style="width: 100%"
        >
          <el-table-column label="排序" type="index" :index='indexMethod'></el-table-column>
          <el-table-column prop="ProductName" label="产品名称" v-if="headBox.type==2"></el-table-column>
          <el-table-column prop="CreateTime" label="销售日期" v-if="headBox.type==1"></el-table-column>
          <el-table-column prop="ActFee" label="销售总金额" ></el-table-column>
          <el-table-column prop="count" label="销售总数量" ></el-table-column>
          <el-table-column prop="address" label="操作" style="text-align:right;"    fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="seeInfoFn(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="productname" label="产品名称" width="200"></el-table-column>
           -->
          </el-table>
        </div>
        
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共{{total}}条记录，</span>
          <span class="demonstration">当前显示第{{data.page}}页</span>
          <el-pagination background layout="prev, pager, next" :total="total" @current-change="List"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </div>
      <!-- 消费统计 -->
      <div v-if="activeIndex==1">
        <!-- <el-row class="conentRow">
          <el-date-picker
            v-model="valueTimes"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
          <el-button class="conentBtn" type="primary" @click="CxXf">查询</el-button>
        </el-row> -->
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          v-loading="loading"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column label="排序" type="index" :index="index2Method"></el-table-column>
          <el-table-column prop="UseTime" label="消费日期" v-if="headBox.type==1"></el-table-column>
          <el-table-column prop="ProductName" label="产品名称" v-if="headBox.type==2"></el-table-column>
          <el-table-column prop="price" label="消费金额"></el-table-column>
          <el-table-column prop="orderformUse" label="消费数量"></el-table-column>
          <el-table-column prop="address" label="操作"    fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="xftjDetailFn(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共{{total1}}条记录，</span>
          <span class="demonstration">当前显示第{{data1.page}}页</span>
          <el-pagination background layout="prev, pager, next" :total="total1" @current-change="List1"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </div>
      <!-- 消费统计结束 -->
      <!-- 退票统计开始 -->
      <div v-if="activeIndex==2">
        <!-- <el-row class="conentRow">
          <el-date-picker
            v-model="data3Time"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
          <el-button class="conentBtn" type="primary" @click="RefundBtns">查询</el-button>
        </el-row> -->
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          v-loading="loading"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column label="序号" type="index" index3Method> </el-table-column>
          <el-table-column prop="ProductName" label="产品名称" v-if="headBox.type=='2'"></el-table-column>
          <el-table-column prop="UseTime" label="退票日期" v-if="headBox.type=='1'"></el-table-column>
          <el-table-column prop="total_Price" label="退票总金额" v-if="headBox.type=='1'"></el-table-column>
          <el-table-column prop="total_use" label="退票总数量" v-if="headBox.type=='1'"></el-table-column>
          <el-table-column prop="price" label="退票总金额" v-if="headBox.type=='2'"></el-table-column>
          <el-table-column prop="orderformUse" label="退票总数量" v-if="headBox.type=='2'"></el-table-column>
          <el-table-column prop="address" label="操作"    fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="detailTickFn(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共{{total3}}条记录，</span>
          <span class="demonstration">当前显示第{{data3.page}}页</span>
          <el-pagination background layout="prev, pager, next" :total="total3" @current-change="paging3"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </div>
      <!-- 退票统计结束 -->
      <!-- 销售记录开始 -->
      <div v-if="activeIndex==3">
        <!-- <el-row class="conentRow">
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
          <el-button class="conentBtn" type="primary">查询</el-button>
        </el-row> -->
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column prop="name" label="产品名称"></el-table-column>
          <el-table-column prop="address" label="时间"></el-table-column>
          <el-table-column prop="address" label="总销售额"></el-table-column>
        </el-table>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共几条记录，</span>
          <span class="demonstration">当前显示第几页</span>
          <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </div>
      <!-- 销售记录结束 -->
      <!-- 消费记录开始 -->
      <div v-if="activeIndex==4">
        <el-row class="conentRow">
          <el-input placeholder="请输入订单号"></el-input>
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
          <el-select v-model="value" clearable placeholder="全部产品">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-button class="conentBtn" type="primary">查询</el-button>
          <el-button class="conentBtn2" type="primary">导出报表</el-button>
        </el-row>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column prop="name" label="景区名称"></el-table-column>
          <el-table-column prop="address" label="订单号"></el-table-column>
          <el-table-column prop="address" label="金额"></el-table-column>
          <el-table-column prop="address" label="数量"></el-table-column>
          <el-table-column prop="address" label="产品名称"></el-table-column>
          <el-table-column prop="address" label="验票时间"></el-table-column>
        </el-table>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共几条记录，</span>
          <span class="demonstration">当前显示第几页</span>
          <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </div>
      <!-- 消费记录结束 -->
      <!-- 退票记录开始 -->
      <div v-if="activeIndex==5">
        <el-row class="conentRow">
          <el-input placeholder="请输入订单号"></el-input>
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
          <el-button class="conentBtn" type="primary">查询</el-button>
          <el-button class="conentBtn2" type="primary">导出报表</el-button>
        </el-row>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column prop="name" label="景区名称"></el-table-column>
          <el-table-column prop="address" label="订单号"></el-table-column>
          <el-table-column prop="address" label="退单金额"></el-table-column>
          <el-table-column prop="address" label="数量"></el-table-column>
          <el-table-column prop="address" label="产品名称"></el-table-column>
          <el-table-column prop="address" label="退票时间"></el-table-column>
          <el-table-column prop="address" label="操作"    fixed="right">
            <template slot-scope="scope">
              <el-button type="text">明细</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共几条记录，</span>
          <span class="demonstration">当前显示第几页</span>
          <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </div>
      <!-- 退票记录结束 -->
    </el-card>
    <!-- 销售统计查看详情开始 -->
    <directStaDialog v-if="xstjinfovisible" :type="headBox.type" :fuTimes="headBox.Times" :XFdate="XFdate" ref="xstjinfoDialog" :i="i" :xfProductID="xfProductID"  :xstjinfoId="xstjinfoId" @seeInfoHandle="XsClose"></directStaDialog>
    <!-- 销售统计查看详情结束 -->
    <!-- 消费统计明细开始 -->
    <directStaDialog v-if="detailvisible" :type="headBox.type"  :fuTimes="headBox.Times" :XFdate="XFdate" ref="detailDialog" @XFInfoHandle="XFClose" :xfProductID="xfProductID"></directStaDialog>
    <!-- 消费统计明细结束 -->
    <!-- 退票统计明细开始 -->
    <directStaDialog v-if="refundTicketvisible" :type="headBox.type"  :fuTimes="headBox.Times" :XFdate="XFdate" ref="refundTicketDialog" :Tprow="Tprow" @TpClose="TpClose" :xfProductID="xfProductID"></directStaDialog>
    <!-- 退票统计明细结束 -->
  </div>
</template>

<script>
import directStaDialog from "./dialog/directStaDialog.vue";
import {Message} from 'element-ui'
import {SalesStatistics, DirectSellingTJ,TicketConsumeTJ,RefundTJ,GetScenicList,
  ProductIDSalesStatistics,TotalSales,
  GeneralLedger,ProductTicketConsumeTJ,
  RefundGeneralLedger,
  ProductRefundTotal,
  exportSalesStatistics,TicketConsumeTJExport,RefundDateExport} from '@/request/scenic.js'
export default {
  components: {
    directStaDialog
  },
  data() {
    return {
      xstjinfovisible: false, // 销售统计查看详情
      detailvisible: false, // 消费统计明细
      refundTicketvisible: false, // 退票统计明细
      tableData: [
      ],
      tabBtn: [
        {
          id: 1,
          name: "销售统计"
        },
        {
          id: 2,
          name: "消费统计"
        },
        {
          id: 3,
          name: "退票统计"
        },
        // {
        //   id: 4,
        //   name: "销售记录"
        // },
        // {
        //   id: 5,
        //   name: "消费记录"
        // },
        // {
        //   id: 6,
        //   name: "退票记录"
        // }
      ],
      upOption: [
        {
          id: 1,
          value: "是"
        },
        {
          id: 2,
          value: "否"
        }
      ],
      value: "",
      activeIndex: "0", // 选中tab
      xstjinfoId:'',
      XFdate:'',
      data3:{
        token:window.sessionStorage.getItem('Token'),
        page_size:10,
        page:1,
        start_date:'',
        end_date:''
      },
      total3:0,
      loading:true,
      Tprow:'',
      // 直销统计
      distri:[
        {
          text:'',
          text1:'销售总数量',
          num:'0',
          suffix:'单',
          img:require('../../../images/report/table.png')
        },
        {
          text:'',
          text1:'销售总数量',
          num:'0',
          suffix:'元',
          img:require('../../../images/report/money.png')
        }
      ],
      xfProductID:'',
      data:{
        token:window.sessionStorage.getItem('Token'),
        starttime:'',
        endtime:'',
        ProductID:'',
        page_size:10,
        page:1
      },
      headBox:{
        Times:'',
        productid:'',
        disid:'',
        type:'1'
      },
      option:[
          {
            value:'1',
            label:'每日'
          },
          {
            value:'2',
            label:'产品'
          }
      ],
      total:0,
      proDuctOption:[],
      data1:{
        token:window.sessionStorage.getItem('Token'),
        starttime:'',
        endtime:'',
        ProductID:'',
        page_size:10,
        page:1
      },
      total1:0,    
      i:''
      
    };
  },
  created(){
    this.data.starttime = this.GetDateStr(-1)  + ' 00:00:00'
    this.data.endtime = this.GetDateStr(0)   + ' 23:59:59'
    this.headBox.Times = [this.GetDateStr(-1),this.GetDateStr(0)]
    this.getProductList()
    let data = {
      token:window.sessionStorage.getItem('Token'),
      page:1,
      page_size:999
    }
    GetScenicList(data).then(res=>{
      if(res.data.status=='ok'){
        this.proDuctOption = res.data.result.data
      }
    })
    this.getnum1(0)
  },
  methods: {
    exportRoute(){
      this.$router.push({
        name:'report',
        params:{
            id:2,
            data:this.headBox,
            index:this.activeIndex
        }
      })
    },
    dayexport(i){
      let data = {
          token:window.sessionStorage.getItem('Token'),
          starttime:this.headBox.Times[0] ,
          endtime:this.headBox.Times[1]
        }
      if(i==0){
        exportSalesStatistics(data).then(res=>{
          if(res.data.status=='ok'){
            window.location.href = res.data.result
          }
        })
      }else if(i==1){
        TicketConsumeTJExport(data).then(res=>{
          
          if(res.data.status=='ok'){
            window.location.href = res.data.result
          }
        })
      }else{
        RefundDateExport(data).then(res=>{
          if(res.data.status=='ok'){
            window.location.href = res.data.result
          }
        })
      }
    },
    // 数量与价格
    getnum1(i){
      if(i==0){
        TotalSales(this.data).then(res=>{
            if(res.data.status=='ok'){
              this.distri[0].num = res.data.result[0].count==null?0:res.data.result[0].count
              this.distri[1].num = res.data.result[0].ActFee==null?0:res.data.result[0].ActFee
            }
        })
      }else if(i==1){
        GeneralLedger(this.data1).then(res=>{
          if(res.data.status=='ok'){
              this.distri[0].num = res.data.result[0].orderformUse==null?0:res.data.result[0].orderformUse
              this.distri[1].num = res.data.result[0].CountPrice==null?0:res.data.result[0].CountPrice
            }
        })
      }else{
        this.data3.starttime = this.data3.start_date
        this.data3.endtime = this.data3.endtime
        RefundGeneralLedger(this.data3).then(res=>{
          if(res.data.status=='ok'){
            this.distri[0].num = res.data.result[0].orderformUse==null?0:res.data.result[0].orderformUse
            this.distri[1].num = res.data.result[0].CountPrice==null?0:res.data.result[0].CountPrice
          }
        })
      }
    },
    // 查询
    chaxun(){
      if(this.activeIndex==0){
        if(this.headBox.Times){
          this.data.starttime =  this.headBox.Times[0]  + ' 00:00:00'  //this.GetDateStr(-1)  
          this.data.endtime =  this.headBox.Times[1]   + ' 23:59:59'
        }else{
          Message.error('请选择时间')
          return false
        }
        if(this.headBox.type=='1'){
          this.data.ProductID = ''
          this.getProductList()
        }else{
          // if(this.headBox.productid==''){
          //   Message.error('请选择产品')
          //   return false
          // }else{
            this.getProductIdList()
          // }
        }
      }
      if(this.activeIndex==1){
        if(this.headBox.Times){
          this.data1.starttime =  this.headBox.Times[0]   + ' 00:00:00' //this.GetDateStr(-1)  
          this.data1.endtime =  this.headBox.Times[1]   + ' 23:59:59'
        }else{
          Message.error('请选择时间')
          return false
        }
        if(this.headBox.type=='1'){
          this.data1.ProductID = ''
          this.getTickList()
        }else{
          // if(this.headBox.productid==''){
          //   Message.error('请选择产品')
          //   return false
          // }else{
            this.getTickIdList()
          // }
        }
      }
      if(this.activeIndex==2){
        if(this.headBox.Times){
          this.data3.start_date =  this.headBox.Times[0]  + ' 00:00:00' //this.GetDateStr(-1)  
          this.data3.end_date =  this.headBox.Times[1]  + ' 23:59:59'
        }else{
          Message.error('请选择时间')
          return false
        }
        if(this.headBox.type=='1'){
          this.data3.ProductID = ''
          this.getefundTJList()
        }else{
          // if(this.headBox.productid==''){
          //   Message.error('请选择产品')
          //   return false
          // }else{
            this.getRefundList()
          // }
        }
      }
      this.getnum1(this.activeIndex)
    },
    // table 排序
    indexMethod(index){
      return (this.data.page - 1) * this.data.page_size + index + 1
    },
    index2Method(index){
      return (this.data1.page - 1) * this.data1.page_size + index + 1
    },
    index3Method(index){
      return (this.data3.page - 1) * this.data3page_size + index + 1
    },
    // 退票搜索
    RefundBtns(){
      this.total3 = 0
      this.data3.page = 1
      this.loading = true
      this.getefundTJList()
    },
    // 退票分页
    paging3(e){
      this.data3.page = e
        this.loading = true
      if(this.headBox.type==1){
        this.getefundTJList()
      }else{
        this.getRefundList()
      }
    },
    // 退票列表
    getefundTJList(){
      RefundTJ(this.data3).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
          this.total3 = res.data.result.total
          this.loading = false
        }
      })
    },
    // 退票产品列表
    getRefundList(){
      this.data3.starttime = this.data3.start_date
      this.data3.endtime = this.data3.end_date
      ProductRefundTotal(this.data3).then(res=>{
        if(res.data.status=='ok'){
          console.log(res)
          this.tableData = res.data.result.data
          this.total3 = res.data.result.total
          this.loading = false
        }
      })
    },
    // 关闭直销统计
    XsClose(){
      this.xstjinfoId = ''
      this.xstjinfovisible = false
      this.XFdate = ''
    },
    // 销售自然日列表
    getProductList(){
      SalesStatistics(this.data).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result[0].data
          this.total = res.data.result[0].total
          this.loading = false
        }
      })
      // DirectSellingTJ(this.data).then(res=>{
      //   if(res.data.status=='ok'){
      //     this.tableData = res.data.result.data
      //     this.total = res.data.result.total
      //     this.loading = false
      //   }
      // })
    },
    // 销售分页
    List(e){
      this.data.page = e
      if(this.headBox.type==1){
        this.getProductList()
      }else{
        this.getProductIdList()
      }
    },
    // 销售产品列表
    getProductIdList(){
      this.data.ProductID = this.headBox.productid
      ProductIDSalesStatistics(this.data).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
          this.total = res.data.result.total
          this.loading = false
        }
      })
    },
    // 消费自然日列表
    getTickList(){
      TicketConsumeTJ(this.data1).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
          this.total1 = res.data.result.total
          this.loading = false
        }
      })
    },
    // 消费产品列表
    getTickIdList(){
      ProductTicketConsumeTJ(this.data1).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
          this.total1 = res.data.result.total
          this.loading = false
        }
      })
    },
    // 消费分页
    List1(e){
      this.loading = true
      this.data1.page = e
      if(this.headBox.type=='1'){
          this.getTickList()
      }else{
          this.getTickIdList()
      }
    },
    // 退票统计明细
    detailTickFn(row) {
      this.refundTicketvisible = true;
      this.Tprow = row
      this.XFdate = row.UseTime
      this.$nextTick(() => {
        this.$refs.refundTicketDialog.detailTick(row);
      });
    },
    // 退票统计明细 x
    TpClose(){
      this.refundTicketvisible = false;
      this.Tprow = ''
      this.XFdate = ''
    },
    // 消费统计明细
    xftjDetailFn(row) {
      this.detailvisible = true;
      if(row.ProductID){
        this.xfProductID = row.ProductID
      }
      this.XFdate = row.UseTime
      this.$nextTick(() => {
        this.$refs.detailDialog.Detail(row);
      });
    },
    XFClose(){
      this.detailvisible = false;
      this.XFdate = ''
    },
    // 销售统计查看详情
    seeInfoFn(row) {
      if(row.ProductID){
        this.xstjinfoId = row.ProductID
      }
      this.XFdate = row.CreateTime
      this.i = 0 
      this.xstjinfovisible = true;
      this.$nextTick(() => {
        this.$refs.xstjinfoDialog.seeInfo(row);
      });
    },
    tabTitle(index) {
      this.loading = true
      this.activeIndex = index;
      this.tableData = []
      if(this.activeIndex=='1'){
        this.data1.page = 1
        this.data1.starttime = this.GetDateStr(-1)  + ' 00:00:00'
        this.data1.endtime = this.GetDateStr(0)  + ' 23:59:59'
        this.headBox.Times = [this.data1.starttime,this.data1.endtime]
        this.headBox.type = '1'
        this.getTickList()
        this.getnum1(1)
      }else if(this.activeIndex=='0'){
        this.data.page=1
        this.data.starttime= this.GetDateStr(-1)  + ' 00:00:00'
        this.data.endtime= this.GetDateStr(0)   + ' 23:59:59'
        this.headBox.Times = [this.data.starttime,this.data.endtime]
        this.headBox.type = '1'
        this.getProductList()
        this.getnum1(0)
      }else if(this.activeIndex=='2'){
        this.data3.start_date = this.GetDateStr(-1)  + ' 00:00:00'
        this.data3.end_date = this.GetDateStr(0)   + ' 23:59:59'
        this.headBox.Times = [this.data3.start_date,this.data3.end_date]
        this.headBox.type = '1'
        this.getefundTJList()
        this.getnum1(2)
      }
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    },
    GetDateStr(AddDayCount) {
      var dd = new Date();
      dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
      var y = dd.getFullYear();
      var m = dd.getMonth()+1;//获取当前月份的日期
      var d = dd.getDate();
      m = (m > 9) ? m : ("0" + m);
      d = (d < 10) ? ("0" + d) : d;
      return y+"-"+m+"-"+d;
    },
  }
};
</script>

<style lang='less' scoped>
.titleSear {
  margin-bottom: 20px;
  .el-input {
    width: 300px;
  }
  .el-button {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    border: none;
    margin-left: 20px;
  }
}
.conentRow {
  display: flex;
  margin-bottom: 20px;
  .el-date-editor {
    margin-right: 20px;
  }
  .el-input {
    width: 250px;
    margin-right: 20px;
  }
  .el-select {
    width: 220px;
    margin-right: 20px;
  }
  .conentBtn {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    border: none;
    color: #ffffff;
    border: none;
    margin-right: 10px;
  }
  .conentBtn2 {
    background: #ffffff;
    border: 1px solid #246deb;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #246deb;
    box-sizing: border-box;
  }
}

.qxsq {
  // 分页
  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
    margin: 30px auto 20px;
    span {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
    }
  }
}

.tab {
  display: flex;
  margin: 20px 0;
  .activeTab {
    background: #246deb;
  }
  span {
    width: 120px;
    height: 40px;
    display: block;
    border-radius: 0px 0px 4px 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 40px;
    color: #ffffff;
    border: none;
    text-align: center;
    background: #d9d9d9;
    margin-right: 20px;
  }
}
// /deep/.el-dialog__header {
//   height: 60px;
//   line-height: 60px;
//   padding: 0;
// }

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 45px auto 40px;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}

.title_box{
  width: 100%;
  background: #fff;
  padding: 2rem;
  box-sizing: border-box;
  margin-top: 2rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  /deep/.el-select{
    margin-right: 2rem;
    width:22rem;
  }
  /deep/.el-date-editor{
    margin-right: 2rem;
    width:28rem;
  }
  span{
    color: #666;
  }
}
.chaxuns{
  width: 10rem;
  height: 4rem;
  border-radius: 0.4rem;
  background: #246DEB;
  color: #fff;
  font-size: 1.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.statistics{
  margin: 2rem 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  >div{
    position: relative;
    width: 39rem;
    height: 15rem;
    border-radius: 0.4rem;
    background: #fff;
    margin-right: 2rem;
    padding: 1.7rem 2rem;
    box-sizing: border-box;
    .tics_title{
      display: flex;
      align-items: center;
      span{
        color: #333;
        font-size: 1.4rem;
        &:nth-child(1){
          font-family: OPPOSans;
        }
        &:nth-child(2){
          color: #666666;
          margin-left: 0.3rem;
        }
      }
    }
    .tics_imgs{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 3.7rem;
      img{
        width: 5.4rem;
        height: 6rem;
      }
      div{
         span{
          color: #246DEB;
          font-size: 4rem;
          &:nth-child(1){
            font-family: OPPOSans;
          }
          &:last-child{
            color: #797979;
            font-size: 2rem;
            margin-left: 0.9rem;
          }
         }
      }
    }
  }
}
/deep/ .el-card {
  box-shadow: none;
}

</style>